<template>
  <VNavigationDrawer v-model="drawer" :rail="rail" permanent>
    <template #prepend>
      <TheSideBarHeader v-model:rail="rail" />
    </template>

    <TheSideBarList v-model:rail="rail" />

    <template #append>
      <TheSideBarFooter :rail="rail" />
    </template>
  </VNavigationDrawer>
</template>

<script lang="ts" setup>
import { VNavigationDrawer } from 'vuetify/components'
import { ref } from 'vue'
import TheSideBarList from './TheSideBarList/TheSideBarList.vue'
import TheSideBarHeader from './TheSideBarHeader/TheSideBarHeader.vue'
import TheSideBarFooter from './TheSideBarFooter/TheSideBarFooter.vue'

const rail = ref(false)
const drawer = ref(true)
</script>
